export enum ViewModes {
  Site = 'Site',
  Editor = 'Editor',
  Preview = 'Preview',
  Dashboard = 'Dashboard',
}
